import { QrCodeVisitStatus, QrCodeVisitWeb } from 'graphql/generated/graphqlTypes';

export enum PastVisitStatFilter {
  All = 'all',
  CheckedIn = 'checkedIn',
  Expired = 'expired'
}

export interface PastVisitStats {
  checkedIn: number;
  expired: number;
}

export const computePastVisitStats = (visits: QrCodeVisitWeb[]): PastVisitStats => ({
  checkedIn: visits.filter((v) => v.status === QrCodeVisitStatus.Used).length,
  expired: visits.filter((v) => v.status === QrCodeVisitStatus.Valid).length
});

export const filterPastVisitsByStat = (visits: QrCodeVisitWeb[], filter: PastVisitStatFilter): QrCodeVisitWeb[] => {
  switch (filter) {
    case PastVisitStatFilter.CheckedIn:
      return visits.filter((v) => v.status === QrCodeVisitStatus.Used);
    case PastVisitStatFilter.Expired:
      return visits.filter((v) => v.status === QrCodeVisitStatus.Valid);
    case PastVisitStatFilter.All:
    default:
      return visits;
  }
};
